export const ASMAN_STORE_CONSTANT = 'asset-management';
